export enum TranslationLocale {
  German = "de",
  French = "fr",
  Italian = "it",
  English = "en",
}
